import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

interface PageLayoutProps {
  children: ReactNode
  className?: string
  backgroundBlobs?: ReactNode | null
}

export function PageLayout({ children, className, backgroundBlobs }: PageLayoutProps) {
  return (
    <div className={cn(
      "min-h-screen w-full flex flex-col bg-background font-display text-foreground antialiased overflow-x-hidden transition-colors duration-200 relative selection:bg-primary/20",
      className
    )}>
      {/* Background Blobs - Default to Soft Pop Vibes if not provided or explicitly null */}
      {/* Background Blobs - Only render if explicitly provided */}
      {backgroundBlobs}

      {/* Content wrapper with z-index to stay above blobs - min-h-screen garante rodapé no fundo */}
      <div className="relative z-10 flex min-h-0 flex-1 flex-col">
        {children}
      </div>
    </div>
  )
}
